import { mapObjectize } from 'cityads-v3/utils/apiUtils';

import {
  ADV_TRAFFIC_TYPE_SET_FORM,

  GET_TRAFFIC_TYPES,
  GET_TRAFFIC_TYPES_SUCCESS,
  GET_TRAFFIC_TYPES_FAIL,

  GET_TRAFFIC_TYPES_ADV,
  GET_TRAFFIC_TYPES_ADV_SUCCESS,
  GET_TRAFFIC_TYPES_ADV_FAIL,

  SAVE_TRAFFIC_TYPES_ADV,
  SAVE_TRAFFIC_TYPES_ADV_SUCCESS,
  SAVE_TRAFFIC_TYPES_ADV_FAIL,

  GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY,
  GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_SUCCESS,
  GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_FAIL,

  GET_CATEGORY_TRAFFIC_TYPES,
  GET_CATEGORY_TRAFFIC_TYPES_SUCCESS,
  GET_CATEGORY_TRAFFIC_TYPES_FAIL,

  GET_OFFER_TRAFFIC_TYPES,
  GET_OFFER_TRAFFIC_TYPES_SUCCESS,
  GET_OFFER_TRAFFIC_TYPES_FAIL,

  GET_OFFER_CUSTOM_TRAFFIC_TYPES,
  GET_OFFER_CUSTOM_TRAFFIC_TYPES_SUCCESS,
  GET_OFFER_CUSTOM_TRAFFIC_TYPES_FAIL,
} from 'cityads-v3/actions/trafficTypes';

import 'array.prototype.fill';

export const TRAFFIC_TYPE_ID_PAID_SEARCH         = 1;
export const TRAFFIC_TYPE_ID_BANNERS             = 2;
export const TRAFFIC_TYPE_ID_RICHMEDIA           = 3;
export const TRAFFIC_TYPE_ID_EMAIL               = 4;
export const TRAFFIC_TYPE_ID_SOCIAL_NETWORK      = 5;
export const TRAFFIC_TYPE_ID_PRICE               = 6;
export const TRAFFIC_TYPE_ID_COUPONS             = 7;
export const TRAFFIC_TYPE_ID_CASHBACK            = 8;
export const TRAFFIC_TYPE_ID_TEASERS             = 9;
export const TRAFFIC_TYPE_ID_CLICKUNDER_POPUNDER = 10;
export const TRAFFIC_TYPE_ID_DOORWAYS            = 11;
export const TRAFFIC_TYPE_ID_CONTENT_SITES       = 12;
export const TRAFFIC_TYPE_ID_BROKER_TRAFFIC      = 13;
export const TRAFFIC_TYPE_ID_INCENTIVE           = 14;
export const TRAFFIC_TYPE_ID_SMS                 = 15;
export const TRAFFIC_TYPE_ID_PUSH_ADS            = 16;
export const TRAFFIC_TYPE_ID_TOOLBAR             = 17;
export const TRAFFIC_TYPE_ID_ARBITRATION_SYSTEM  = 18;
export const TRAFFIC_TYPE_ID_COUPONS_CACHBACK    = 19;
export const TRAFFIC_TYPE_ID_YOUTUBE_CHANNEL     = 20;
export const TRAFFIC_TYPE_ID_BEGUN               = 21;
export const TRAFFIC_TYPE_ID_BEING_ADS           = 22;
export const TRAFFIC_TYPE_ID_GOOGLE_ADWORDS      = 23;
export const TRAFFIC_TYPE_ID_YAHOO               = 24;
export const TRAFFIC_TYPE_ID_YANDEX_DIRECT       = 25;
export const TRAFFIC_TYPE_ID_ADV_IN_GROUPS       = 26;
export const TRAFFIC_TYPE_ID_ADV_IN_PROFILE      = 27;
export const TRAFFIC_TYPE_ID_VKONTAKTE           = 28;
export const TRAFFIC_TYPE_ID_FACEBOOK            = 29;
export const TRAFFIC_TYPE_ID_INSTAGRAM           = 30;
export const TRAFFIC_TYPE_ID_TARGETED_ADS_IN_SOCIAL_NETWORKS = 36;

export const TRAFFIC_TYPE_VALUE_DISALLOWED = 1
export const TRAFFIC_TYPE_VALUE_ALLOWED = 2;

export const customFields = length => Array(length > 0 ? length : 0)
  .fill()
  .map((item, num) => ({
    isCustom        : true,
    isNew           : true,
    type_traffic_id : num+1+'',
    id              : num+1+'',
    value           : null,
    comment         : ''
  }))

const CUSTOM_FIELD_COUNT = 3;

export const BANNED_TRAFFIC_TYPE_IDS = [TRAFFIC_TYPE_ID_FACEBOOK, TRAFFIC_TYPE_ID_INSTAGRAM];

const initialState = {
  trafficTypes: [],
  trafficTypesById: {},
  categoryTrafficTypes: {},
  categoryTrafficTypesLoading: {},
  isLoading: false,
  isLoaded: false,
  trafficTypesAdv: [],
  trafficTypeIdsByActionTypeDirectionIdAndCategoryId: {},
  trafficTypesLoadingByActionTypeDirectionIdAndCategoryId: {},
  trafficTypesLoadedByActionTypeDirectionIdAndCategoryId: {},

  offerTrafficTypesByOfferIdAndTTId: {},
  offerTrafficTypesLoadingByOfferId: {},
  offerTrafficTypesLoadedByOfferId: {},

  offerCustomTrafficTypesByOfferId: {},
  offerCustomTrafficTypesLoadingByOfferId: {},
  offerCustomTrafficTypesLoadedByOfferId: {},

  advForm: {
    ...customFields(CUSTOM_FIELD_COUNT).reduce((prev, next) => ({ ...prev, [next.type_traffic_id]: next }), {})
  },
  actionName: null,

  isSavingTrafficTypesAdv: false,
  isSavedTrafficTypesAdv: false,
};

export default function trafficTypes(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TRAFFIC_TYPES:
      return {
        ...state,
        isLoading: true,
      }

    case GET_TRAFFIC_TYPES_SUCCESS:
      const trafficTypes = action.response.trafficType || []
      const trafficTypesById = mapObjectize(trafficTypes.map(item => ({ ...item, id: +item.id })));
      return {
        ...state,
        trafficTypes: trafficTypes.sort((a, b) => +a.position - +b.position).map(item => +item.id),
        trafficTypesById,
        isLoading: false,
        isLoaded: true,
      }

    case GET_TRAFFIC_TYPES_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
      }

    case GET_TRAFFIC_TYPES_ADV:
      return {
        ...state,
        isLoadingAdv: true,
        isLoadedAdv: false,
        isLoadingAdvError: false,
      }

    case GET_TRAFFIC_TYPES_ADV_SUCCESS:
      const { traffic_types_custom = [] } = action.response;
      const trafficTypesAdv = action.response.traffic_types || [];

      const trafficTypesAdvCustom = ([
        ...traffic_types_custom,
        ...customFields(CUSTOM_FIELD_COUNT - traffic_types_custom.length)
      ]).map(item => ({
        ...item,
        type_traffic_id: -item.id,
        isCustom: true
      }));

      const trafficTypesAdvById = mapObjectize(trafficTypesAdv, 'type_traffic_id');
      const advForm = [...trafficTypesAdv, ...trafficTypesAdvCustom].reduce((prev, next) => ({
        ...prev,
        [next.type_traffic_id]: {
          ...next,
          value: next.allow === null ? null : next.allow ? 'allow' : 'deny',
          comment: next.comment || ''
        }
      }), {});
      return {
        ...state,
        trafficTypesAdv: trafficTypesAdv.map(item => item.type_traffic_id),
        trafficTypesAdvById,
        isLoadingAdv: false,
        isLoadedAdv: true,
        advForm,
        actionName: action.response.offer && action.response.offer.name
      }

    case GET_TRAFFIC_TYPES_ADV_FAIL:
      return {
        ...state,
        isLoadingAdv: false,
        isLoadedAdv: false,
        isLoadingAdvError: true
      }

    case ADV_TRAFFIC_TYPE_SET_FORM:
      const value = {};
      if (action.value !== undefined) {
        value.value = action.value;
        value.allow = action.value === 'allow';
      }
      if (action.comment !== undefined) {
        value.comment = action.comment;
      }
      if (action.name !== undefined) {
        value.name = action.name;
      }

      return {
        ...state,
        advForm: {
          ...state.advForm,
          [action.id]: {
            ...state.advForm[action.id],
            ...value
          }
        }
      }

    case SAVE_TRAFFIC_TYPES_ADV:
      return {
        ...state,
        isSavingTrafficTypesAdv: true,
        isSavedTrafficTypesAdv: false,
      }

    case SAVE_TRAFFIC_TYPES_ADV_SUCCESS:
      return {
        ...state,
        isSavingTrafficTypesAdv: false,
        isSavedTrafficTypesAdv: true,
      }

    case SAVE_TRAFFIC_TYPES_ADV_FAIL:
      return {
        ...state,
        isSavingTrafficTypesAdv: false,
        isSavedTrafficTypesAdv: true,
      }

    case GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY:
      return {
        ...state,
        trafficTypesLoadingByActionTypeDirectionIdAndCategoryId: {
          ...state.trafficTypesLoadingByActionTypeDirectionIdAndCategoryId,
          [action.additional.actionTypeDirectionId]: {
            ...(state.trafficTypesLoadingByActionTypeDirectionIdAndCategoryId[action.additional.actionTypeDirectionId] || {}),
            [action.additional.categoryId]: true
          },
        },
      };

    case GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_SUCCESS:
      return {
        ...state,
        trafficTypesById: {
          ...state.trafficTypesById,
          ...mapObjectize(action.response.trafficType.map(item => ({ ...item, id: +item.id }))),
        },
        trafficTypeIdsByActionTypeDirectionIdAndCategoryId: {
          ...state.trafficTypeIdsByActionTypeDirectionIdAndCategoryId,
          [action.additional.actionTypeDirectionId]: {
            ...(state.trafficTypeIdsByActionTypeDirectionIdAndCategoryId[action.additional.actionTypeDirectionId] || {}),
            [action.additional.categoryId]: action.response.trafficType.sort((a, b) => +a.position - +b.position).map(item => item.id)
          },
        },
        trafficTypesLoadingByActionTypeDirectionIdAndCategoryId: {
          ...state.trafficTypesLoadingByActionTypeDirectionIdAndCategoryId,
          [action.additional.actionTypeDirectionId]: {
            ...(state.trafficTypesLoadingByActionTypeDirectionIdAndCategoryId[action.additional.actionTypeDirectionId] || {}),
            [action.additional.categoryId]: false
          },
        },
        trafficTypesLoadedByActionTypeDirectionIdAndCategoryId: {
          ...state.trafficTypesLoadedByActionTypeDirectionIdAndCategoryId,
          [action.additional.actionTypeDirectionId]: {
            ...(state.trafficTypesLoadedByActionTypeDirectionIdAndCategoryId[action.additional.actionTypeDirectionId] || {}),
            [action.additional.categoryId]: true
          },
        },
      };

    case GET_TRAFFIC_TYPES_BY_TYPE_AND_CATEGORY_FAIL:
      return {
        ...state,
        trafficTypesLoadingByActionTypeDirectionIdAndCategoryId: {
          ...state.trafficTypesLoadingByActionTypeDirectionIdAndCategoryId,
          [action.additional.actionTypeDirectionId]: {
            ...(state.trafficTypesLoadingByActionTypeDirectionIdAndCategoryId[action.additional.actionTypeDirectionId] || {}),
            [action.additional.categoryId]: false
          },
        },
      };

    case GET_OFFER_TRAFFIC_TYPES:
      return {
        ...state,
        offerTrafficTypesLoadingByOfferId: {
          ...state.offerTrafficTypesLoadingByOfferId,
          [action.additional.offerId]: true,
        },
      };

    case GET_OFFER_TRAFFIC_TYPES_SUCCESS:
      return {
        ...state,
        offerTrafficTypesByOfferIdAndTTId: {
          ...state.offerTrafficTypesByOfferIdAndTTId,
          [action.additional.offerId]: mapObjectize(action.response.offerTrafficType, 'traffic_type_id'),
        },
        offerTrafficTypesLoadingByOfferId: {
          ...state.offerTrafficTypesLoadingByOfferId,
          [action.additional.offerId]: false,
        },
        offerTrafficTypesLoadedByOfferId: {
          ...state.offerTrafficTypesLoadedByOfferId,
          [action.additional.offerId]: true,
        },
      };

    case GET_OFFER_TRAFFIC_TYPES_FAIL:
      return {
        ...state,
        offerTrafficTypesLoadingByOfferId: {
          ...state.offerTrafficTypesLoadingByOfferId,
          [action.additional.offerId]: false,
        },
      };

    case GET_OFFER_CUSTOM_TRAFFIC_TYPES:
      return {
        ...state,
        offerCustomTrafficTypesLoadingByOfferId: {
          ...state.offerCustomTrafficTypesLoadingByOfferId,
          [action.additional.offerId]: true,
        },
      };

    case GET_OFFER_CUSTOM_TRAFFIC_TYPES_SUCCESS:
      return {
        ...state,
        offerCustomTrafficTypesByOfferId: {
          ...state.offerCustomTrafficTypesByOfferId,
          [action.additional.offerId]: action.response.offerCustomTrafficType,
        },
        offerCustomTrafficTypesLoadingByOfferId: {
          ...state.offerCustomTrafficTypesLoadingByOfferId,
          [action.additional.offerId]: false,
        },
        offerCustomTrafficTypesLoadedByOfferId: {
          ...state.offerCustomTrafficTypesLoadedByOfferId,
          [action.additional.offerId]: true,
        },
      };

    case GET_OFFER_CUSTOM_TRAFFIC_TYPES_FAIL:
      return {
        ...state,
        offerCustomTrafficTypesLoadingByOfferId: {
          ...state.offerTrafficTypesLoadingByOfferId,
          [action.additional.offerId]: false,
        },
      };

    case GET_CATEGORY_TRAFFIC_TYPES:
      return {
        ...state,
        categoryTrafficTypesLoading: {
          [action.additional.categoryId]: true
        }
      }

    case GET_CATEGORY_TRAFFIC_TYPES_SUCCESS:
      return {
        ...state,
        categoryTrafficTypesLoading: {
          [action.additional.categoryId]: false
        },
        categoryTrafficTypes: {
          [action.additional.categoryId]: action.response.categoryTrafficType.map(item => ({
            id: +item.id,
            category_id: +item.category_id,
            traffic_type_id: +item.traffic_type_id,
            action_type_direction_id: +item.action_type_direction_id,
            value: +item.value,
          }))
        }
      }

    case GET_CATEGORY_TRAFFIC_TYPES_FAIL:
      return {
        ...state,
        categoryTrafficTypesLoading: {
          [action.additional.categoryId]: false
        },
      }

    default:
      return state;
  }
}
